// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sRG_","col":"styles_col__7EA5O"};